import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./NavBar.css";
import Logo from '../assets/images/logo.png'
import { FaBars, FaTimes } from 'react-icons/fa';
import { FaExternalLinkAlt } from "react-icons/fa";

const NavBar = () => {
    const [click, setClick] = useState(false);

    const handleClick = () => setClick(!click);
    return (
        <>
            <nav className="navbar">
                <div className="nav-container">

                    <div className="nav-logo">
                        <NavLink to="/" className="logo-image">
                            <img src={Logo} alt="logo" className="" />
                        </NavLink>
                    </div>

                    <ul className={click ? "nav-menu active" : "nav-menu"}>
                        <li className="nav-item">
                            <NavLink
                                to="/"
                                className={({ isActive }) => (isActive ? 'active-nav' : 'nav-links')}
                                onClick={handleClick}
                            >
                                Home
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                to="/dams"
                                className={({ isActive }) => (isActive ? 'active-nav' : 'nav-links')}
                                onClick={handleClick}
                            >
                                Dams
                            </NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink
                                to="/projected-risk"
                                className={({ isActive }) => (isActive ? 'active-nav' : 'nav-links')}
                                onClick={handleClick}
                            >
                                Projected Risk
                            </NavLink>
                        </li>

                        <li className="nav-item">
                            <a href='https://amanchaudhary.users.earthengine.app/view/geoid--lulc-analysis#lat=23.7;lon=78.5;zoom=5;' className='nav-link' target="_blank" rel="noreferrer noopener">
                                LULC Analysis <FaExternalLinkAlt/>
                            </a>
                        </li> 
                        <li className="nav-item">
                            <NavLink
                                to="/contact"
                                className={({ isActive }) => (isActive ? 'active-nav' : 'nav-links')}
                                onClick={handleClick}
                            >
                                Contact Us
                            </NavLink>
                        </li>



                    </ul>
                    <div className="nav-icon" onClick={handleClick}>
                    {click ? <FaTimes /> : <FaBars />}
                    </div>
                </div>
            </nav>
        </>
    )
}

export default NavBar
